<template>
  <main>
    <contact-us-blurb />
    <div class="container-fluid bg-white pt-3">
      <div class="container">
        <food-navbar current="food-search" />
      </div>
    </div>
    <div class="container-fluid bg-white pt-5">
      <div class="container">
        <food-searchbox
          :on-results="returnData"
          @search-start="isSearching = true"
          @search-end="isSearching = false"
        />
      </div>
    </div>
    <div class="container-fluid bg-white pt-5 pb-5">
      <!-- Search Results -->
      <loading-spinner
        v-if="isSearching"
        :show-spinner="isSearching"
      />

      <div
        v-else
        class="container"
      >
        <pagination
          :params="paginationParams"
          @go-to-page="load_items"
        />
        <food-search-list :items="itemData" />
        <pagination
          :params="paginationParams"
          @go-to-page="load_items"
        />
        <disclaimer-food-search
          :show-disclaimer="showDisclaimer"
          max-width="480px"
        />
      </div>
    </div>
    <tips-modal
      v-show="is_showing_tips_modal"
      :tips="tips"
      @hide-modal="is_showing_tips_modal = false"
    />
  </main>
</template>

<script>
import foodcleaner from '../components/FoodSearchShared'
export default {
  name: 'FoodSearch',
  data() {
    return {
      itemData: null,
      paginationParams:{
        current_page:1,
        total_pages:1
      },
      is_showing_tips_modal: false,
      tips: [
      ],
      query:'',
      showDisclaimer: true,
      isSearching: false,
    };
  },
  async mounted(){
    this.load_items();
    this.load_tips();
  },
  methods: {
    returnData(iteminfoData){
      // Hide disclaimer
      this.showDisclaimer = false;

      this.itemData = foodcleaner.cleanfooditems(iteminfoData.data);
      this.paginationParams = iteminfoData.meta;
      this.query = iteminfoData.query;
    },
    async load_items(page){
      if (this.query === '') {
        return;
      }

      // Show spinner
      this.isSearching = true;

      this.itemData = null;
      let foodItemsrequest = await foodcleaner.search(this.query, page);
      let foodItems = foodcleaner.cleanfooditems(foodItemsrequest.data);
      this.itemData =foodItems;
      this.paginationParams = foodItemsrequest.meta;

      this.isSearching = false;
    },
    async load_tips(){
      const thedate = (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000))
        .toISOString()
        .slice(0, -1)
        .split('T')[0];

      const sessionKey = `dailytips-${thedate}`;

      if(!localStorage.getItem(sessionKey)){
        let tipsRequest = await this.$http('/api/tipsoftheday?date='+thedate,{
          method:"get",
        }).then(response => response.json())
          .then(async function(json) {
            return json;
          });
        if(tipsRequest.length>0){
          this.tips = tipsRequest;
          this.is_showing_tips_modal=true;
          localStorage.setItem(sessionKey, "viewed");
        }else{
          this.tips=[];
        }
      }

    }
  }
};
</script>

<style lang="scss" scoped>

</style>
